<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import VueSweetalert2 from "vue-sweetalert2";
import ErrorMessage from "../../components/error-message";
import Stat from "../../components/widgets/stat";
/**
 * Basic-table component
 */
export default {
  components: {Stat, ErrorMessage, Layout, PageHeader },
  data() {
    return {
      title: "User Role List",
      items: [
        {
          text: "Role",
          href: "/",
        },
        {
          text: "User Role List",
          active: true,
        },
      ],
      userRoles: [],
        errors:null,
        visible:false,
        message:"",
        user_type:"",
        search_fname:"",
        search_lname:"",
        search_name:"",
        search_email:"",
        search_status:"",
        search:"",
        display_div:true,
    };
  },
  mounted() {
    // this.getRoleList();
  },
    computed: {
        filteredList() {
            return this.userRoles.filter(role => {
                return (role.first_name==null ? '' : role.first_name).toLowerCase().includes(this.search_fname.toLowerCase())
                    && (role.last_name==null ? '' : role.last_name).toLowerCase().includes(this.search_lname.toLowerCase())
                    && (role.status==null ? '' : role.status).toLowerCase().includes(this.search_status.toLowerCase())
                    && (role.email==null ? '' : role.email).toLowerCase().includes(this.search_email.toLowerCase())
            })
        }
    },
  methods: {
      onClose(){
          this.visible=false;
      },
      searchFilterFunc2(val) {
          this.search=val;
      },
      toggleDiv: function() {
          this.display_div = !this.display_div;
      },
    async deleteWarning(user_id,role_id) {
      var _this = this;
      try {
        this.$swal({
          title: "Are you sure?",
          text: "You can't revert your action",
          type: "error",
          showCancelButton: true,
          confirmButtonText: "Yes, Remove Role!",
          cancelButtonText: "No",
          showCloseButton: true,
          showLoaderOnConfirm: true,
        }).then((result) => {
          if (result.value) {
            _this.deleteItem(user_id,role_id,);
          } else {
            this.$swal("Cancelled", "", "info");
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    async search1() {
      try {
        axios
          .post("/api/role/user", {
              accessToken: localStorage.getItem("access_tocken"),
                user_type:this.user_type,
          })
          .then((response) => {
            if (response.data.status) {
              this.userRoles = response.data.data;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.errors = obj.message;
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (obj.message !== "Token has expired") {
        this.errors = obj.message;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data load",
        });
      }
    },
    deleteItem: function deleteItem(user_id,role_id,) {
      var _this = this;
      axios
        .post("/api/role_remove/" + user_id+"/"+role_id, {
          accessToken: localStorage.getItem("access_tocken"),
        })
        .then(function (response) {
         if(response.data.status){
            _this.search1();
         } else {
             var str = response.data.message;
             var jsonParse = JSON.parse(str);
             _this.errorCheck(jsonParse);
         }
        });
    },
  },
};
</script>

<template>
  <Layout @CustomEventInputChangedAll="searchFilterFunc2">
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
      <div class="row">

          <div class="col-lg-12">
              <div class="card">
                  <div class="card-body">
                      <b-button class='float-right' v-if="display_div" v-on:click="toggleDiv()" size="sm">Collapse</b-button>
                      <b-button class='float-right' v-else v-on:click="toggleDiv()" size="sm">Expand</b-button>
                     <div v-if="display_div" class="row">
                         <div class="col-md-6">
                             <div class="form-group">
                                 <label for="user_type">Select User Type</label>
                                 <select
                                     id="user_type"
                                     name="user_type"
                                     v-model="user_type"
                                     class="form-control"
                                     placeholder="Select User Type">
                                     <option value="b2b">B2B
                                     </option>
                                     <option value="b2c">B2C
                                     </option>
                                     <option value="admin">Admin
                                     </option>
                                 </select>
                             </div>
                         </div>
                         <div class="col-md-6 text-center"><span><button class="btn btn-primary button-padding" @click.prevent="search1()">Search</button></span></div>
                     </div>
                  </div>
              </div>
          </div>
      </div>
    <div class="row">

      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive table-responsive-sm">
              <table class="table mb-0 table-striped">
                <thead>
                  <tr>
                    <th>SL</th>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>User Type</th>
                      <th>Email</th>
                    <th>Status</th>
                      <th>Role Name</th>
                  </tr>
                  <tr>
                    <td> &nbsp </td>
                    <td><input type="text" class="app-search form-control" v-model="search_fname" placeholder="Search " /></td>
                    <td><input type="text" class="app-search form-control" v-model="search_lname" placeholder="Search " /></td>
                    <td> &nbsp </td>
                    <td><input type="text" class="app-search form-control" v-model="search_email" placeholder="Search " /></td>
                    <td><input type="text" class="app-search form-control" v-model="search_status" placeholder="Search " /></td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(role,index) in filteredList" v-bind:key="index">
                    <th scope="row">{{index+1}}</th>
                    <td>{{role.first_name== null ? 'N/A' : role.first_name}}</td>
                    <td>{{role.last_name == null ? 'N/A' : role.last_name}}</td>
                    <td>{{role.account_type}}</td>
                      <td>{{role.email}}</td>
                      <td>{{role.status}}</td>
                      <td>
                          <table>
                              <div v-for="(roleName,index2) in role.user_roles" ><td class="padding-4percent">{{roleName.name}} </td><td><button @click.prevent="deleteWarning(role.id,roleName.id)" class="btn btn-danger btn-sm"><i class="fa fa-trash"></i>Delete</button></td></div>
                          </table>
                      </td>

                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
<style scoped>
.padding-4percent {
    width:200px;
}
.btn{
    margin-left:4%;
}
.button-padding{
    margin-top:6%;
}
</style>
